<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstPointsAutomatedItem"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedPointsAutomatedItem"
		dataKey="ID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--PointsAutomatedItemTypeDesc-->
				<th>
					<p-columnFilter field="PointsAutomatedItemTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPointsAutomatedItemTypeDesc
								[ngModel]="value"
								[options]="lstPointsAutomatedItemTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--PointsItemDesc-->
				<th>
					<p-columnFilter field="PointsItemDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPointsItemDesc
								[ngModel]="value"
								[options]="lstPointsItemDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--PointsItemValue-->
				<th>
					<!-- <p-columnFilter type="text" field="PointsItemValue" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--SchoolCount-->
				<th>
					<!-- <p-columnFilter type="text" field="SchoolCount" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="PointsAutomatedItemTypeDesc">Trigger<p-sortIcon field="PointsAutomatedItemTypeDesc"></p-sortIcon></th>
				<th pSortableColumn="PointsItemDesc">Point<p-sortIcon field="PointsItemDesc"></p-sortIcon></th>
				<th pSortableColumn="PointsItemValue">Point Value<p-sortIcon field="PointsItemValue"></p-sortIcon></th>
				<th pSortableColumn="SchoolCount">School Count<p-sortIcon field="SchoolCount"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-PointsAutomatedItem>
			<tr [pSelectableRow]="PointsAutomatedItem" (dblclick)="onRowDblClick(PointsAutomatedItem)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ PointsAutomatedItem[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
